import styles from './blogContent.module.scss'
import Content from 'components/Content'
import Head from 'next/head'

interface BlogContentProps {
  children: React.ReactNode,
  isPost?: boolean,
}

const BlogContent = ({ children, isPost = true }: BlogContentProps) => {
  return <>
    <Head>
      {/* <link rel="preconnect" href="https://fonts.gstatic.com" /> */}
      {/* <link href="https://fonts.googleapis.com/css2?family=Quattrocento+Sans:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" /> */}
    </Head>
    <Content className={isPost ? styles.blogPostContent : styles.blogContent}>
      {children}
    </Content>
  </>
}

export default BlogContent
